var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArquivo01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    d: "M32,34.6H4c-1.9,0-3.5-1.6-3.5-3.5v-21c0-0.4,0.1-0.7,0.4-1l0,0l5.3-7c0.3-0.4,0.9-0.7,1.4-0.7h21 c0.6,0,1.1,0.3,1.4,0.7l5.3,7l0,0c0.2,0.3,0.4,0.7,0.4,1v21C35.5,33.1,34,34.6,32,34.6z M4,11.9v19.3h28V11.9H4z M8.4,4.9L5.7,8.4 h24.5l-2.6-3.5H8.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M23.3,18H12.7v-3.5H9.2v7h17.5v-7h-3.5V18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArquivo01);
export default __webpack_public_path__ + "static/media/ico-arquivo-01.b5425582e0cd1766dc4e9e5e461b4f66.svg";
export { ForwardRef as ReactComponent };